import { useState } from "react";
import { MENU } from "@/data/menu";

export default function MenuBrowser() {
  const [active, setActive] = useState(MENU[0].id);
  const current = MENU.find((m) => m.id === active);

  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="bg-[#F5F2EA] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end md:justify-between gap-6 border-b border-[#E4DECD] pb-10">
          <div>
            <p className="font-mono-accent text-[12px] text-[#7A2021] mb-5">
              — The Carte
            </p>
            <h2
              data-testid="menu-heading"
              className="font-serif-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight text-[#1A1713]"
            >
              The Menu.
            </h2>
          </div>
          <p className="max-w-sm text-[#5C5449] text-base leading-relaxed">
            Twelve sections, more than one hundred and sixty dishes. We change
            quietly with the season — ask your server about today's hand-written
            additions.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-8 md:gap-12">
          {/* Sticky category sidebar */}
          <aside
            data-testid="menu-category-sidebar"
            className="col-span-12 md:col-span-3"
          >
            <div className="md:sticky md:top-32 flex md:flex-col gap-1 md:gap-0 overflow-x-auto md:overflow-visible -mx-6 px-6 md:mx-0 md:px-0 pb-2 md:pb-0">
              {MENU.map((cat) => {
                const isActive = active === cat.id;
                return (
                  <button
                    key={cat.id}
                    onClick={() => setActive(cat.id)}
                    data-testid={`menu-cat-${cat.id}`}
                    className={`group text-left whitespace-nowrap md:whitespace-normal flex-shrink-0 md:w-full px-4 md:px-0 py-3 md:py-4 border-b transition-colors duration-300 ${
                      isActive
                        ? "md:border-[#1A1713] text-[#1A1713]"
                        : "md:border-[#E4DECD] text-[#5C5449] hover:text-[#1A1713]"
                    }`}
                  >
                    <span
                      className={`font-serif-display text-2xl md:text-3xl leading-tight ${
                        isActive ? "italic" : ""
                      }`}
                    >
                      {cat.name}
                    </span>
                    <span className="hidden md:block font-mono-accent text-[11px] mt-1 text-[#7A2021]/80">
                      {String(cat.items.length).padStart(2, "0")} dishes
                    </span>
                  </button>
                );
              })}
            </div>
          </aside>

          {/* Item list */}
          <div className="col-span-12 md:col-span-9">
            <div className="mb-10">
              <p className="font-mono-accent text-[12px] text-[#7A2021] mb-3">
                {current.name}
              </p>
              <h3
                data-testid="menu-section-title"
                className="font-serif-display text-4xl md:text-5xl text-[#1A1713]"
              >
                {current.subtitle}
              </h3>
            </div>

            <ul className="grid grid-cols-1 lg:grid-cols-2 gap-x-12">
              {current.items.map((it, idx) => (
                <li
                  key={`${current.id}-${idx}`}
                  data-testid="menu-item-row"
                  className="flex items-baseline gap-4 py-5 border-b border-[#E4DECD] group"
                >
                  <span className="font-serif-display text-xl md:text-2xl text-[#1A1713] leading-snug">
                    {it.name}
                  </span>
                  <span className="flex-1 border-b border-dotted border-[#1A1713]/20 self-end mb-1.5 mx-2 group-hover:border-[#7A2021]/50 transition-colors" />
                  {it.price ? (
                    <span className="font-mono-accent text-[12px] text-[#7A2021]">
                      ${it.price}
                    </span>
                  ) : (
                    <span className="font-mono-accent text-[12px] text-[#5C5449]">
                      mp
                    </span>
                  )}
                  {it.note && (
                    <div className="block w-full mt-1 text-[#5C5449] text-sm italic">
                      {it.note}
                    </div>
                  )}
                </li>
              ))}
            </ul>

            <p className="mt-10 font-mono-accent text-[12px] text-[#5C5449]">
              mp · market price, hand-written daily.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
